// Mês de 30 dias: o suficiente para uma estimativa de fila, que nunca precisa de calendário.
const UNITS = [
  {id: 'Months', seconds: 30 * 24 * 3600},
  {id: 'Days', seconds: 24 * 3600},
  {id: 'Hours', seconds: 3600},
  {id: 'Minutes', seconds: 60},
  {id: 'Seconds', seconds: 1},
];

/**
 * Duração legível na unidade certa: segundos até 59s, minutos até 59min, depois horas, dias e meses.
 * Mostra a unidade principal e, se houver, a seguinte ("2 min 5 s", "1 h 1 min", "1 dia 3 h"), com os
 * textos vindos do i18n (`reportJobDuration*`).
 *
 * @param {object} intl instância do react-intl
 * @param {number} totalSeconds duração em segundos
 * @return {string} duração formatada
 */
export const formatDuration = (intl, totalSeconds) => {
  const seconds = Math.max(0, Math.round(totalSeconds));
  const found = UNITS.findIndex((unit) => seconds >= unit.seconds);
  const index = found === -1 ? UNITS.length - 1 : found;
  const main = UNITS[index];
  const parts = [{unit: main, count: Math.floor(seconds / main.seconds)}];
  const next = UNITS[index + 1];
  if (next) {
    const count = Math.floor((seconds % main.seconds) / next.seconds);
    if (count > 0) {
      parts.push({unit: next, count});
    }
  }
  return parts
      .map(({unit, count}) => intl.formatMessage({id: `reportJobDuration${unit.id}`}, {count}))
      .join(' ');
};
